export const DEFAULT_IMAGE_NOT_FOUND = "/img/image-not-found.png";
export const API_S3_IMAGES =
  process.env.REACT_APP_API_HOST_URL + "/v1/s3/images";
